import SafeImage from '@ui/SafeImage';
import { ChatMessageDocument } from '@models/chat';

const IMG_SIZE = 500;

interface MessageImageProps {
  message: ChatMessageDocument;
  img: string;
  fallbackImg?: string;
  onClick: (src: string) => void;
  isInbound?: boolean;
  onRightClick?: (ev: React.MouseEvent) => void;
}

export default function MessageImage({
  message,
  img,
  fallbackImg,
  onClick,
  onRightClick,
}: MessageImageProps) {
  if (message.mime_type?.includes('video') && message.content) {
    return (
      <video controls width={IMG_SIZE} onContextMenu={onRightClick}>
        <source width={IMG_SIZE} src={message.content}></source>
        <track kind="captions" src="" srcLang="en" label="English captions" />
      </video>
    );
  }

  return (
    <div className="relative h-[20rem] w-[20rem]" onContextMenu={onRightClick}>
      <SafeImage
        src={img}
        key={img}
        fill
        alt={'img'}
        fallbackSrc={fallbackImg}
        className="cursor-pointer object-cover"
        onClick={() => onClick(img)}
      />
    </div>
  );
}
